module.exports = __webpack_public_path__ + "static/media/35-8.b9fb1223.mp3";